export enum Genre {
	AfroHouse = 'Afro House',
	DeepHouse = 'Deep House',
	OrganicHouse = 'Organic House',
	ProgressiveHouse = 'Progressive House'
}

export const SETS = [
	{
		genres: [Genre.OrganicHouse],
		title: 'CARDACCI #7 - Organic House',
		youtubeId: 'Lg5-T2xcy2o'
	},
	{
		genres: [Genre.DeepHouse],
		title: 'CARDACCI #6 - Deep House',
		youtubeId: 'bc3Vh8DAKi0'
	},
	{
		genres: [Genre.AfroHouse],
		title: 'CARDACCI #5 - Afro House',
		youtubeId: 'vUg6zylWK5s'
	},
	{
		genres: [Genre.OrganicHouse, Genre.ProgressiveHouse],
		title: 'CARDACCI x Fran Barone x SOLER #4 - Organic / Progressive House',
		youtubeId: 'P0haMIdd_j0'
	},
	{
		genres: [Genre.DeepHouse],
		title: 'CARDACCI #3 - Deep House',
		youtubeId: 'KmLM1fLEk0g'
	},
	{
		genres: [Genre.OrganicHouse, Genre.ProgressiveHouse],
		title: 'CARDACCI x Ramiro Avanzi x SOLER #2 - Organic / Progressive House',
		youtubeId: 'gzz-8-d2LxE'
	},
	{
		genres: [Genre.OrganicHouse, Genre.ProgressiveHouse],
		title: 'CARDACCI #1 - Organic / Progressive House',
		youtubeId: 'K-NzdZJZ8pY'
	}
];
